import axios_instance from "@/utils/axios";
import { SignupStep1Schema } from "@/utils/schema.z";
import { LoginInput, SignUp2Input, SignUp3Input } from "@/utils/types/auth.type";

export const LoginMutation = async (data: LoginInput) => {
  const response = await axios_instance.post('/users/login', data);
  console.log(response, 'tessst login')
  return response.data.data;
};

export const signUpStep1Mutation = async (payload: SignupStep1Schema) => {
  const { data } = await axios_instance.post('/auth/sign_up_step1', payload);
  return data.data;
};

export const signUpStep2Mutation = async (payload: SignUp2Input) => {
  const { data } = await axios_instance.post('/auth/sign_up_step2', payload);
  return data.data;
};

export const resendOtpMutation = async (payload: { id: string }) => {
  const { data } = await axios_instance.post('/auth/resend_otp', payload);
  return data.data;
};

export const signUpStep3Mutation = async (payload: SignUp3Input) => {
  const { data } = await axios_instance.post('/auth/sign_up_step3', payload);
  return data.data;
};

export const emailChecker = async (payload: {email : string}) => {
  const { data } = await axios_instance.post('/auth/check_email', payload);
  return data;
};

export const getEvearaToken = async () => {
  const { data } = await axios_instance.get('/auth/evearaToken');
  return data.data;
};


export const uploadTrack = async (file: File) => {
  const formData = new FormData();
  formData.append("track_file", file);

  const { data } = await axios_instance.post("/auth/uploadTrack", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data.data;
};

export const LogoutMutation = async () => {
  const response = await axios_instance.post('/users/logout');
  return response.data;
};

export const forgotPasswordRequestMutation = async (payload: { email: string }) => {
  const { data } = await axios_instance.post('/auth/password-reset-request', payload);
  return data;
};

export const resetPasswordMutation = async (payload: { email: string; token: string; password: string }) => {
  const { data } = await axios_instance.post('/auth/password-reset', payload);
  return data;
};

export const onboardingCompleteMutation = async (payload: { id: string }) => {
  const { data } = await axios_instance.post('/auth/onboarding_complete', payload);
  return data.data;
};

export const changePasswordMutation = async (payload: { currentPassword: string; newPassword: string; logoutOtherDevices?: boolean }) => {
  const { data } = await axios_instance.put('/users/change-password', payload);
  return data;
};
